import { render, staticRenderFns } from "./home-partners.vue?vue&type=template&id=e1b77658&scoped=true"
import script from "./home-partners.vue?vue&type=script&lang=js"
export * from "./home-partners.vue?vue&type=script&lang=js"
import style0 from "./home-partners.vue?vue&type=style&index=0&id=e1b77658&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1b77658",
  null
  
)

export default component.exports